// Certificates & registrations. Actual documents uploaded by the company are served
// from /public/certificates. Set `image` to null to fall back to the placeholder.
export const CERTIFICATIONS = [
  {
    id: "iso-9001-2015",
    title: "ISO 9001:2015",
    subtitle: "Quality Management System",
    description:
      "Our quality management approach is aligned with ISO 9001:2015, reinforcing consistent processes across manufacturing and supply.",
    image: null,
  },
  {
    id: "udyam",
    title: "UDYAM",
    subtitle: "MSME Registration — Micro Enterprise",
    description:
      "Registered under UDYAM as a Micro enterprise with Manufacturing as the major activity — a focused Indian engineering and manufacturing enterprise.",
    image: "/certificates/udyam.jpeg",
  },
  {
    id: "gst",
    title: "GST",
    subtitle: "GST Registration",
    description:
      "GST-registered entity, enabling transparent and compliant commercial engagements across India.",
    image: "/certificates/gst.jpeg",
  },
];
